/**
 * @description createUserMessage is a function which is used to create a user message object.
 * @param {string} message - the message to be sent to the server
 * @param {string} profilePhoto - the profile photo of the user
 * @param {string} key - the key of the message
 * @returns {object} userMessage object
 * @example
 * const userMessage = createUserMessage("Hi", "profilePhoto", "key");
 **/

export const createUserMessage = (message, profilePhoto, key) => {
  const userMessage = {
    key,
    answer: message,
    profilePhoto,
    messageSender: "user",
    cta_results: [],
    recommended_questions: [],
  };
  return userMessage;
};

/**
 * @description createBotMessage is a function which is used to create a bot message object.
 * @param {string} message - the message to be sent to the server
 * @param {string} profilePhoto - the profile photo of the user
 * @param {string} key - the key of the message
 * @returns {object} botMessage object
 * @example
 * const botMessage = createBotMessage("Hi", "profilePhoto", "key");
 * */

export const createBotMessage = (
  profilePhoto,
  key,
  answer,
  cta_results,
  recommended_questions,
  id
) => {
  const botMessage = {
    key,
    answer,
    cta_results,
    recommended_questions,
    profilePhoto,
    id,
    messageSender: "bot",
  };

  return botMessage;
};
